import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import Search from '../../assets/images/svg/search.svg';

const chipStyle = {
    backgroundColor: '#6366F1',
    color: 'white',
    padding: '4px 10px',
    borderRadius: '6px',
    fontSize: '13px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
};

const chipBoxStyle = {
    minHeight: '80px',
    maxHeight: '100px',
    border: '1px solid #E2E8F0',
    backgroundColor: '#FAFAFA',
    borderRadius: '6px',
    padding: '10px',
    overflowY: 'auto',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
    alignContent: 'flex-start',
};

const inputStyle = {
    height: '46px',
    border: '1px solid #E2E8F0',
    backgroundColor: '#FFFFFF',
    borderRadius: '6px',
};

const labelStyle = {
    color: '#4A5568',
    fontWeight: '500',
    fontSize: '16px',
};

const RelationPicker = ({
    label,
    searchValue,
    onSearchChange,
    results,
    idKey,
    nameKey,
    selected,
    onSelect,
    onRemove,
}) => {
    const normalizedSearch = searchValue.toLowerCase();
    const filteredResults = results
        .filter((result) => (result[nameKey] || '').toLowerCase().includes(normalizedSearch))
        .filter((result) => !selected.some((item) => item[idKey] === result[idKey]));

    return (
        <Row className='mb-3'>
            <Col md={4}>
                <Form.Group>
                    <Form.Label className="mb-2" style={labelStyle}>{label}</Form.Label>
                    <div className="position-relative">
                        <Form.Control
                            type="text"
                            placeholder={typeof label === 'string' ? `Search ${label}...` : 'Search...'}
                            value={searchValue}
                            onChange={(e) => onSearchChange(e.target.value)}
                            style={{ ...inputStyle, paddingRight: '35px' }}
                        />
                        <img
                            src={Search}
                            alt="search"
                            className="position-absolute"
                            style={{
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                width: '16px',
                                height: '16px',
                                pointerEvents: 'none',
                            }}
                        />
                        {searchValue.length > 0 && (
                            <div
                                className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}
                            >
                                {filteredResults.map((result) => (
                                    <div
                                        key={result[idKey]}
                                        className="p-2"
                                        onClick={() => {
                                            onSelect(result);
                                            onSearchChange('');
                                        }}
                                        style={{ cursor: 'pointer' }}
                                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#F3F4F6'; }}
                                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'white'; }}
                                    >
                                        {result[nameKey]}
                                    </div>
                                ))}
                                {filteredResults.length === 0 && (
                                    <div className="p-2 text-muted text-center">No results</div>
                                )}
                            </div>
                        )}
                    </div>
                </Form.Group>
            </Col>
            <Col md={8}>
                <Form.Group>
                    <Form.Label className="mb-2" style={labelStyle}>Selected</Form.Label>
                    <div style={chipBoxStyle}>
                        {selected.length === 0 && (
                            <span style={{ color: '#A0AEC0', fontSize: '13px' }}>None selected</span>
                        )}
                        {selected.map((item) => (
                            <span key={item[idKey]} style={chipStyle}>
                                {item[nameKey]}
                                <button
                                    type="button"
                                    aria-label={`Remove ${item[nameKey]}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        onRemove(item[idKey]);
                                    }}
                                    className="border-0 bg-transparent text-white"
                                    style={{
                                        padding: 0,
                                        lineHeight: 1,
                                        fontSize: '18px',
                                        fontWeight: '700',
                                        cursor: 'pointer',
                                        opacity: 0.95,
                                    }}
                                >
                                    &times;
                                </button>
                            </span>
                        ))}
                    </div>
                </Form.Group>
            </Col>
        </Row>
    );
};

export default RelationPicker;

